import { useState, useEffect } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.pageYOffset > 600);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed bottom-28 right-8 w-14 h-14 bg-[#f5272b] hover:bg-red-700 text-white rounded-2xl shadow-2xl hover:shadow-[#f5272b]/50 flex items-center justify-center transition-all duration-500 z-50 group
        ${visible ? "opacity-100 scale-100" : "opacity-0 scale-0 pointer-events-none"}
      `}
    >
      <i className="text-xl transition-transform fa-solid fa-arrow-up group-hover:-translate-y-1"></i>
    </button>
  );
}
